import { render, staticRenderFns } from "./FinalizedBiddersList.vue?vue&type=template&id=72671715&scoped=true&"
import script from "./FinalizedBiddersList.vue?vue&type=script&lang=js&"
export * from "./FinalizedBiddersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72671715",
  null
  
)

export default component.exports